(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["slides-2026-coordination-gossip"] = factory();
	else
		root["slides-2026-coordination-gossip"] = factory();
})(globalThis, () => {
return 